function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { blue30 } from "@churchofjesuschrist/eden-style-constants";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { Menu } from "@churchofjesuschrist/eden-icons";
const Button = styled(Icon).withConfig({
  componentId: "sc-vhlesp-0"
})(["color:", ";&:hover{color:", ";}"], blue30, blue30);
/** A button used to open a WorkforceHeader menu. */

export default function MenuButton(_ref) {
  let {
    "aria-label": ariaLabel = "Menu",
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": ariaLabel,
    onClick: onClick,
    title: ariaLabel
  }, rest), /*#__PURE__*/React.createElement(Menu, null));
}
MenuButton.propTypes = {
  /** Handler when the button is clicked. */
  onClick: PropTypes.func.isRequired,

  /** The label for the button. Will also be used for the defaut `title` attribute value.  */
  "aria-label": PropTypes.string
};